import React, { useEffect } from'react';
import { useState,useCallback } from 'react';
import {  useTranslation } from "react-i18next";
import { useQueryClient,useQuery } from 'react-query';
import UseGameSvcLstQuery from 'Apis/GameSvcLstInqApi';
import UseLangCdLstQuery from 'Apis/LangLstInqApi';
import UseLangLstQuery from 'Apis/LangTxtInqApi';

import IsMntnInqApi from 'Apis/IsMntnInqApi';

import MembNrmlLogoutApi from 'Apis/MembNrmlLogoutApi';
import i18n from "Lang/i18n";
import {Link, useNavigate, useLocation} from "react-router-dom";
import SmartLink from '../../Components/SmartLink';
import { useDispatch, useSelector} from 'react-redux';
import "Assets/css/GlbHdr.css"
import { LangSetStateChng ,AppDispatch} from 'Stores/LangSetReducer';
import GameSvcLstDataType from "Interface/Apis/GameSvcLst.Interface";
import LangCdLstType from 'Interface/Apis/LangCdLst.Interface';
import MgpStore from "Stores/Store";
import { LoginInfoStateChng } from 'Stores/LoginInfoReducer';

const GlbHdrUi = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch<AppDispatch>();
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const {data: langCdLstData}:any = UseLangCdLstQuery();
    const {data: gameSvcLstData}:any = UseGameSvcLstQuery();

    const [sideMenustates, setSideStat] = useState(false);
    const [langSelectMenuStates, setLangSelectMenuStates] = useState(false);
    const [pcMenustates, setPCmenuStat] = useState(false);
    
    // useSelector로 실시간 로그인 상태 구독
    const loginInfoState = useSelector((state: any) => state.LoginInfoState?.LoginInfo?.apiBody);
    

    useEffect(()=>{
        
        IsMntnInqApi("mgp")
        .then((Resp) => {
        });
    },[]);
    
    const { t } =useTranslation();

    const LangSetFunc = (e:string) => {
        console.log('LangSetFunc called with:', e);
        console.log('Current language state:', MgpStore.getState().LangSetState.Lang);
        
        dispatch(LangSetStateChng(e));
        
        console.log('Language state after dispatch:', MgpStore.getState().LangSetState.Lang);
        
        // ToggleLocales(e);
        setSideStat(sideMenustates => false);
        setPCmenuStat(pcMenustates => false);
        setLangSelectMenuStates(false);
    }
    const ToggleLocales = useCallback(
        (Lang: string) => {
            i18n.changeLanguage(Lang);
        },
        [i18n]
    );

    const SideMenuToggle = () => {
        setSideStat(sideMenustates => !sideMenustates);
    }
    const LangSelectMenuToggle = () => {
        setLangSelectMenuStates(langSelectMenuStates => !langSelectMenuStates);
    }
    
    const ResetMenuToggle = () => {
        setSideStat(sideMenustates => false);
        setPCmenuStat(pcMenustates => false);
    }

    const PCMenuToggle = () => {
        setPCmenuStat(pcMenustates => !pcMenustates);
        if(pcMenustates != true) {
            
        }
    }
    const logoutFunc = () => {
        MembNrmlLogoutApi()
        .then((resp)=>{
            window.location.reload();
        });        
    }
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (765/2));
    const GameMnyPopFunc = (e:any)=>{
        window.open(e,"_blank","width=500,height=765 left="+popupX+"top="+popupY);
    }
    return (
        <>
            <header className='glbHdrWrap'>
                <div className='dFlex gap20'>
                    <div className='menuBtn' onClick={()=>SideMenuToggle()}>
                        <img src={process.env.PUBLIC_URL+'/images/hdrSideMenuIcon.png'} />
                        <p>{langData&&langData.GLB_HDR_SIDE_MENU_BTN_00}</p>
                    </div>
                    <SmartLink to={"/"} onClick={()=>ResetMenuToggle()}>
                        <img src={process.env.PUBLIC_URL+'/images/homeButtonIcon.png'} alt="홈버튼" />
                    </SmartLink>
                </div>
     
                {/* <Link to="/" className='mainHomeBtn'>
                    <img src={process.env.PUBLIC_URL+'/images/moveintFullLogo.svg'} alt="React" className='glbHdrMoveLogo'/>
                </Link>                    */}
                {
                    loginInfoState&&loginInfoState.login == true ?
                    <div className='isLoginWrap'>
                        {/* <div className='flexLoginLink'>
                            {loginInfoState.ntfyMsgCnt != 0 ? 
                                <div className='loginLink'>
                                    <Link to={"/MyPage/NtfyMsgLst"} className='NtfyMsgIconWrap'>
                                        <img src={process.env.PUBLIC_URL + "/images/NtfyMsgIcon.png"} alt="" />
                                        <div className='ntfyMstCnt'>
                                            {
                                                loginInfoState.ntfyMsgCnt > 9 ?
                                                <p>9+</p>
                                                :
                                                <p>{loginInfoState.ntfyMsgCnt}</p>
                                            }
                                        </div>
                                    </Link>
                                </div>
                                : ""
                            }
                            <div className='loginLink '>
                                <Link to={"/MyPage"}>
                                    <img className='membIconImg' src={process.env.PUBLIC_URL + "/images/membIcon.png"} alt="" />
                                </Link>
                            </div>
                        </div> */}
                        <div className='loginLink'>
                            <button onClick={()=> logoutFunc()}>
                                <p>
                                    {langData&&langData.COMM_MAIN_LOGOUT_MAIN_BTN_00}
                                </p>
                            </button>
                        </div>
                    </div>
                    :<div className='isLoginWrap'>
                        <div className='loginLink'>
                            <Link to={`/MembJoin?referrer=${encodeURIComponent(location.pathname + location.search)}`}>
                                <p>{langData&&langData.GLB_HDR_MEMB_JOIN_BTN_00}</p>
                            </Link>
                        </div>
                        <div className='loginLink'>
                            <Link to={`/Login?referrer=${encodeURIComponent(location.pathname + location.search)}`}>
                                <p>{langData&&langData.COMM_MAIN_LOGIN_MAIN_BTN_00}</p>
                            </Link>
                        </div>
                    </div>
                }
                
            </header>
            <div className={sideMenustates?"sideMenu active":"sideMenu"}>
                <div className="sideMenuBg" onClick={()=>SideMenuToggle()}></div>
                <div className='subMenuWrap'>
                    <div className='closeBtnWrap'>
                        <button className='closeBtn' onClick={()=>SideMenuToggle()}>
                            <img src={process.env.PUBLIC_URL+'/images/sideMenuCloseIcon.png'} alt="SideMenuCloseImg" />
                        </button>
                    </div>
                    <div className="subMenuLst">
                        {/* <h2>{data&&data.GLB_HDR_PC_GAME_LBL_00}</h2> */}
                        <div className="gameSvcLstWrap">
                            <h3>{langData&&langData.GLB_HDR_PC_GAME_LBL_00}</h3>
                            <ul>
                                {gameSvcLstData&&gameSvcLstData.map((key:GameSvcLstDataType) => (
                                     <li key={key.gameSvcCd}>
                                         <SmartLink to={key.gameUrl} onClick={()=>ResetMenuToggle()}>
                                             <p>{key.gameNm}</p>
                                             <div className='gamePltfIconWrap'>
                                                 <p>{key.gamePltf}</p>
                                             </div>
                                         </SmartLink>
                                     </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="subMenuBottom">
                        <ul>
                            {/* <li>
                                <Link to='/MyPage' onClick={()=>ResetMenuToggle()}>
                                    <p>{langData&&langData.GLB_HDR_MYPAGE_MAIN_BTN_00}</p>
                                </Link>
                            </li> */}
                            {/* <li>
                                <button onClick={()=>GameMnyPopFunc(`/GameMnyDpstPop?lang=${MgpStore.getState().LangSetState.Lang}`)}>
                                    <p>{langData&&langData.GLB_HDR_MNY_DPST_BTN_00}</p>
                                </button>
                            </li> */}
                            <li>
                                <SmartLink to='/Cs/Main' forceFull onClick={()=>ResetMenuToggle()}>
                                    <p>{langData&&langData.GLB_HDR_CS_MAIN_BTN_00}</p>
                                </SmartLink>
                            </li>
                            {loginInfoState&&loginInfoState.login != true ?
                            <li>
                                <p onClick={() => LangSelectMenuToggle()}> {langData&&langData.GLB_HDR_LANG_CHNG_BTN_00}</p>
                                <div className='langLstWrap'>

                                    <ul className={langSelectMenuStates?"langLstUl active":"langLstUl"}>
                                        {
                                            langCdLstData&&langCdLstData.map((key:LangCdLstType, index:number) => {
                                               
                                                return (
                                                    <li key={index}>
                                                        <button onClick={() => LangSetFunc(key.langCd)}>{key.langNm}</button>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                            </li>:
                            <></>
                            }
                        </ul>

                    </div>
                </div>
            </div>
        </>
    )
}

export default GlbHdrUi;